import round from 'lodash/round';

export default function generateEqualShares(countries) {
  const countriesCount = countries.length;
  const perCountryShare = round(100 / countriesCount / 100, 4);
  const shares = {};
  const allCountriesButLast = countries.slice(0, countriesCount - 1);
  const lastCountry = countries[countriesCount - 1];

  allCountriesButLast.forEach(({ countryCode }) => {
    shares[countryCode] = perCountryShare;
  });
  shares[lastCountry.countryCode] = round(
    1 - perCountryShare * (countriesCount - 1),
    4,
  );

  return shares;
}
